import React from "react";
import { useParams } from "react-router-dom";
import { Check, ClipboardList } from "lucide-react";
import { SiteLayout } from "@/components/layout/SiteLayout";
import { PageHero } from "@/components/layout/PageHero";
import { CtaBand } from "@/components/layout/CtaBand";
import { Section, SectionHeading } from "@/components/layout/Section";
import { MicroLabel } from "@/components/common/MicroLabel";
import { Reveal } from "@/components/common/Reveal";
import { SERVICE_CATEGORIES } from "@/content/pagesContent";
import NotFound from "@/pages/NotFound";

export default function ServiceCategory() {
  const { slug } = useParams();
  const cat = SERVICE_CATEGORIES[slug];
  if (!cat) return <NotFound />;

  return (
    <SiteLayout>
      <PageHero
        testId={`service-${slug}-page`}
        micro={cat.micro}
        title={cat.title}
        description={cat.description}
      />

      <Section id="service-detail-section" tone="offwhite">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          {/* casi d'uso */}
          <Reveal>
            <div className="h-full rounded-2xl border border-strato-gray-100 bg-strato-white p-7">
              <MicroLabel variant="blue">CASI D'USO</MicroLabel>
              <h2 className="mt-3 font-display text-xl font-medium text-strato-graphite">
                Quando è la scelta giusta
              </h2>
              <ul className="mt-5 space-y-3">
                {cat.useCases.map((u) => (
                  <li key={u} className="flex items-start gap-3">
                    <span className="mt-0.5 grid h-6 w-6 flex-shrink-0 place-items-center rounded-full bg-[var(--strato-blue-soft)] text-strato-blue">
                      <Check className="h-3.5 w-3.5" strokeWidth={2.5} />
                    </span>
                    <span className="text-sm leading-[1.55] text-strato-graphite">{u}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          {/* cosa serve per valutare */}
          <Reveal delay={0.08}>
            <div className="h-full rounded-2xl border border-strato-gray-100 bg-strato-white p-7">
              <MicroLabel variant="blue">COSA SERVE PER VALUTARE</MicroLabel>
              <h2 className="mt-3 font-display text-xl font-medium text-strato-graphite">
                Per un preventivo preciso
              </h2>
              <ul className="mt-5 space-y-3">
                {cat.evaluate.map((e, i) => (
                  <li key={e} className="flex items-start gap-3">
                    <span className="strato-micro mt-1 w-6 flex-shrink-0 text-strato-gray-300">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="text-sm leading-[1.55] text-muted-foreground">{e}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.12}>
          <div className="mt-6 flex items-center gap-3 rounded-2xl border border-strato-gray-100 bg-strato-white px-5 py-4">
            <ClipboardList className="h-5 w-5 flex-shrink-0 text-strato-blue" />
            <p className="text-sm text-muted-foreground">
              Non hai tutto? Nessun problema: partiamo da ciò che hai e definiamo insieme il resto.
            </p>
          </div>
        </Reveal>
      </Section>

      <CtaBand secondaryTo="/servizi" secondaryLabel="Tutti i servizi" />
    </SiteLayout>
  );
}
